import script from "./InspectorMaterial.vue?vue&type=script&setup=true&lang=js"
export * from "./InspectorMaterial.vue?vue&type=script&setup=true&lang=js"

import "./InspectorMaterial.vue?vue&type=style&index=0&id=28c01060&lang=scss&scoped=true"
import "./InspectorMaterial.vue?vue&type=style&index=1&id=28c01060&lang=scss"

import exportComponent from "/usr/local/tomcat-jenkins/data/workspace/online-3d-editor-laozicloud3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28c01060"]])

export default __exports__